import jwtAuthAxios from "../../services/jwtAuth";
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { generateTemplate } from "configs/utils/Excel";

export const getAllMasterRuang = createAsyncThunk("masterRuang/getAllMasterRuang", 
    async(_, { rejectWithValue }) => {
        try{
            const token = localStorage.getItem('auth_token');
            jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
            const url = `v1/master_ruang`
            const { data } = await jwtAuthAxios.get(url)
            return data;
        } catch(err){
            rejectWithValue(err?.response?.data?.message || 'error')
        }
    }
);

export const downloadTemplateExcel = createAsyncThunk("masterRuang/downloadTemplateExcel",
	async (payload, { rejectWithValue }) => {
		try {
			const workbook = await generateTemplate(payload);

			// Save to blob
            const buffer = await workbook.xlsx.writeBuffer();
            const blob = new Blob([buffer], { 
				type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
			});
            const url = URL.createObjectURL(blob);

            // Create a temporary link element
            const link = document.createElement('a');
            link.href = url;
            link.download = 'bobot_penilaian_data.xlsx';

            // Trigger a click on the link to initiate the download
            link.click();

            // Cleanup
            URL.revokeObjectURL(url);
		} catch(e) {
			rejectWithValue({
				message: e.data.message || e.message
			})
		}
	}
);

const initialState = {
    dataAll: [],
	loading: false,
}

const masterRuang = createSlice({
    name:"masterRuang",
    initialState,
    reducers: {
		onRefreshLoading: (state) => {
			state.loading = initialState.loading;
		}
    },
    extraReducers: (builder) => {
    builder
        .addCase(getAllMasterRuang.pending, (state) => {
            state.loading = true;
        })
        .addCase(getAllMasterRuang.fulfilled, (state, action) => {
            state.dataAll = action.payload;
            state.loading = false;
        })
        .addCase(getAllMasterRuang.rejected, (state) => {
            state.loading = false;
        })
    }
})

export const {
	onRefreshLoading,
} = masterRuang.actions

export const selectMasterRuang = (state) => state.masterRuang;
export default masterRuang.reducer;